<template>
    <div>
        <!-- Selecionar Profisisonais -->
        <div class="modal fade" id="selecMedicosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="lista">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar Profissionais</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info p-2 d-flex justify-content-between">
                            <div>{{ lista.filter(item => item.tem_certificado).length }} Selecionados</div>
                            <div><a href="#" @click="limpar_selecao_medicos()"><i class="fa-solid fa-xmark"></i></a></div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 d-flex flex-column">
                                <az-input   
                                    sizing="sm"
                                    type="button-group" 
                                    :optionsList="[
                                        { id: 'T', search: 'Todos' },
                                        { id: 'P', search: 'Profissionais' },
                                        { id: 'A', search: 'Agendas' }
                                    ]"
                                    optionsData="id" 
                                    v-model="filtro_lista"/>
                            </div>
                        </div>

                        <table class="table table-sm border-0 table-responsive" v-if="lista_classes && lista_classes.length">
                            <tr>
                                <td class="text-nowrap">
                                    <a href="#" @click.prevent="classe == classe_selecionada ? classe_selecionada = '' : classe_selecionada = classe" v-for="(classe, icx) in lista_classes" :key="icx">
                                        <span class="badge mr-1" :class="classe == classe_selecionada ? 'badge-success' : 'badge-secondary'">
                                            {{ classe }}
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        </table>

                        <div v-if="classe_selecionada">
                            <button type="button" class="btn btn-sm btn-outline-primary mb-3" @click="marcar_todos_classe()">
                                Todos
                            </button>
                        </div>

                        <table class="table table-sm">
                            <tr v-for="(medico, imx) in lista_exibicao" :key="imx">
                                <td width="1%">
                                    <input type="checkbox" v-model="medico.tem_certificado" />
                                </td>
                                <td width="99%">
                                    <i class="fa-solid fa-calendar fa-fw mr-2 text-muted" v-if="medico.fl_agenda_compartilhada"></i>
                                    <i class="fa-solid fa-user-doctor fa-fw mr-2 text-muted" v-else></i>
                                    <a href="#" @click.prevent="selecionar_medico(medico)" class="card-link">
                                        {{ medico.st_nome_exibicao }}
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="filtrar_selecao_medicos()">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
  components: { AzInput },
    data() {
        return { 
            lista: null, 
            classe_selecionada: "", 
            filtro_lista: "T", 
        }
    },

    computed: { 
        lista_exibicao: function () { 
            if ( !this.lista )
                return [];

            return this.lista.filter(item => this.filtro_lista == 'T' 
                    || ( this.filtro_lista == 'P' && !item.fl_agenda_compartilhada )
                    || ( this.filtro_lista == 'A' && item.fl_agenda_compartilhada )
                )
                .filter(item => !this.classe_selecionada || ( item.js_classes && item.js_classes.includes(this.classe_selecionada)));
        },

        lista_classes: function () { 
            if ( !this.lista || !this.lista.length ) { 
                return [];
            }

            return _.uniq(this.lista.flatMap(item => item.js_classes ? item.js_classes : [])).sort();
        }
    },

    methods: { 
        selecionar_medico (medico) { 
            this.limpar_selecao_medicos();
            medico.tem_certificado = true;
            this.filtrar_selecao_medicos();
        },

        marcar_todos_classe () { 
            let selec = this.lista_exibicao.find(item => !item.tem_certificado);

            this.lista_exibicao.forEach(item => {
                item.tem_certificado = selec;
            });
        },

        abrir_carregando (parms, selecionados = null) { 

            this.$util.loadItem(this, { 
                service: "medicos",
                func: "index",
                parms: parms, 
            })
            .then(lista => { 
                this.abrir(lista, selecionados);
            });
            
        },

        abrir (lista, selecionados = null) { 

            console.log('lista', lista);

            this.lista = _.cloneDeep(lista).map(item => { 
                    item.tem_certificado = ( selecionados && selecionados.includes(item.id_pessoa) ) ? true : false;
                    return item; 
                });

            $('#selecMedicosModal').modal('show');
        },

        limpar_selecao_medicos () { 
            this.lista.forEach(item => {
                item.tem_certificado = false;
            });
        },

        filtrar_selecao_medicos() { 
            $('#selecMedicosModal').modal('hide');
            this.$emit('selecionados', this.lista.filter(item => item.tem_certificado));
        }
    }
}
</script>
